import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect, lazy, Suspense } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Footer from './components/Footer';
import { trackPageView } from './analytics';

const WatchSection = lazy(() => import('./components/WatchSection'));
const Features = lazy(() => import('./components/Features'));
const Notifications = lazy(() => import('./components/Notifications'));
const FaqCTA = lazy(() => import('./components/FaqCTA'));
const FAQ = lazy(() => import('./pages/FAQ'));
const Contact = lazy(() => import('./pages/Contact'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./pages/TermsOfService'));

const PAGE_TITLES = {
  '/':               'Home',
  '/faq':            'FAQ',
  '/contact':        'Contact',
  '/privacy-policy': 'Privacy Policy',
  '/terms-of-service': 'Terms of Service',
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    trackPageView(pathname, PAGE_TITLES[pathname] ?? pathname);
  }, [pathname]);
  return null;
}

function Home() {
  return (
    <div className="bg-gray-50 min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Suspense fallback={null}>
          <WatchSection />
          <Notifications />
          <Features />
          <FaqCTA />
        </Suspense>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
